import React from 'react';
import { Link } from 'react-router-dom';
import SVGRecipeCard from '../../svg/RecipeCard';

const ImageUploadView = props => {
  const {
    image,
    openEdit,
    deleteImage,
    title = 'Photo',
    isEdit = true,
    showPreview = true
  } = props;
  const hasImage = image && 'id' in image;

  if (!isEdit && !image) return '';

  return (
    <div className="cms__section">
      <div className="cms__bar cms__section-head">
        <div className="cms__bar-left">
          <h3 className="h3">{title}</h3>
        </div>
        <div className="cms__bar-right">
          {renderEditButton(hasImage, isEdit, deleteImage, image)}
        </div>
      </div>
      {renderView(hasImage, showPreview, image)}
      {renderAddButton(hasImage, openEdit, isEdit)}
    </div>
  );
};

const renderView = (hasImage, showPreview, image) => {
  if (hasImage && !showPreview)
    return (
      <div className="cms__section-body">
        <div className="image-upload__placeholder-icon">
          <SVGRecipeCard />
        </div>
        <p className="image-upload__placeholder">
          <a href={image.url} className="a--blue" target="_blank" download>
            {image.image_name}
          </a>
        </p>
      </div>
    );

  if (hasImage && showPreview)
    return <img className="image-upload__img" src={image.url} alt="" />;
};

const renderEditButton = (hasImage, isEdit, deleteImage, image) => {
  if (hasImage && isEdit) {
    return (
      <div>
        <Link to={image.url} className="a--blue" target="_blank" download>
          Download
        </Link>
        <span className="a--red image-upload__delete" onClick={deleteImage}>
          Delete
        </span>
      </div>
    );
  }
};

const renderAddButton = (hasImage, openEdit, isEdit) => {
  if (!hasImage && isEdit)
    return (
      <div className="btn btn--white btn--full-width" onClick={openEdit}>
        + Upload
      </div>
    );
};

export default ImageUploadView;



// WEBPACK FOOTER //
// ./src/components/shared/ImageUploadView.js